import {
  USER_ROLES,
  type UserAuthDetail,
} from 'src/tpbp-core/models/auth/auth.types'
import type { PersonModel } from 'src/tpbp-json-api-handler/models/models'

export interface CurrentUserState {
  currentUser: PersonModel
  currentUserAuthDetail: UserAuthDetail
  userIdsForIndicators: string[]
}

export const DEFAULT_CURRENT_USER_STATE: CurrentUserState = {
  currentUser: {} as PersonModel,
  currentUserAuthDetail: {
    role: USER_ROLES.NONE,
    precisions: [],
  },
  userIdsForIndicators: [],
}
